import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AggregateService {

  constructor(private http: HttpClient) { }

  getSummary(startDT: Date, endDT: Date) {
    return this.http
      .post(
        `/api/v1/aggregate/summary`,
        { start_dt: startDT.toISOString(), end_dt: endDT.toISOString() }
      );
  }

  getDetail(startDT: Date, endDT: Date) {
    return this.http
      .post(
        `/api/v1/aggregate/detail`,
        { start_dt: startDT.toISOString(), end_dt: endDT.toISOString() }
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/aggregate.service.ts